import {
  CONSENT_CHANGED_EVENT,
  hasAnalyticsConsent,
  isMarketingAttributionCookieConsentGateEnabled,
} from 'common/utils/cookie-consent';
import { readCookie } from 'common/utils/browser-cookie';
import {
  GCLID,
  GCLID_LT,
  LANDING_PAGE_URL,
  LANDING_PAGE_URL_LT,
  PAR,
  PAR_LT,
  REFERRER_URL,
  REFERRER_URL_LT,
} from './attribution-cookies';

function getParameterByName(name, url) {
  const targetUrl = url || window.location.href;
  const escapedName = name.replace(/\[|\]/g, '\\$&');
  const regex = new RegExp(`[?&]${escapedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(targetUrl);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function createCookie(name, value, days) {
  if (!value) {
    return;
  }
  let expires = '';
  const duration = days || 90;
  const date = new Date();
  date.setTime(date.getTime() + duration * 24 * 60 * 60 * 1e3);
  expires = `; expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}${expires};domain=${document.location.hostname};path=/`;
}

function getAttribution() {
  return {
    gclid: getParameterByName('gclid'),
    par: getParameterByName('par'),
    referrer: document.referrer,
    landingPage: document.location.href,
  };
}

function applyAttribution({ gclid, par, referrer, landingPage }) {
  createCookie(GCLID_LT, gclid);
  createCookie(PAR_LT, par);
  createCookie(REFERRER_URL_LT, referrer);
  createCookie(LANDING_PAGE_URL_LT, landingPage);

  if (gclid && readCookie(GCLID) === null) {
    createCookie(GCLID, gclid);
  }
  if (par && readCookie(PAR) === null) {
    createCookie(PAR, par);
  }
  if (readCookie(REFERRER_URL) === null) {
    createCookie(REFERRER_URL, referrer);
  }
  if (readCookie(LANDING_PAGE_URL) === null) {
    createCookie(LANDING_PAGE_URL, landingPage);
  }
}

export function initializeMarketingAttribution() {
  const attribution = getAttribution();

  if (isMarketingAttributionCookieConsentGateEnabled()) {
    window.addEventListener(CONSENT_CHANGED_EVENT, () => {
      if (hasAnalyticsConsent()) {
        applyAttribution(attribution);
      }
    });

    if (hasAnalyticsConsent()) {
      applyAttribution(attribution);
    }
  } else {
    applyAttribution(attribution);
  }
}
